








"use client";

import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaPaperPlane,
} from "react-icons/fa";
import { STRAPI_URL } from "@/lib/strapi";

// ---------------- Types ----------------
interface SocialLink { id: number; name: string; icon: string; href: string; bg?: string }
interface QuickLink { id: number; name: string; href: string }
interface FooterBottomLink { id: number; name: string; href: string }
interface ContactItem { id: number; type: string; value: string; icon: string }
interface FooterData {
  logoName: string
  logoUrl: string | null
  description: string
  newsletterTitle: string
  newsletterText: string
  newsletterPlaceholder: string
  socialLinks: SocialLink[]
  quickLinks: QuickLink[]
  footerBottomLinks: FooterBottomLink[]
  contactInfo: ContactItem[]
}
interface LogoData { namelogo: string; url: string | null; Reference: string }
interface FooterBottomProps { logoUrl: string | null; logoName: string; links: FooterBottomLink[] }

// ---------------- Default Footer Data ----------------
const defaultFooterData: FooterData = {
  logoName: "ENAP",
  logoUrl: null,
  description: "Default company description",
  newsletterTitle: "Newsletter",
  newsletterText: "Subscribe to our newsletter for updates",
  newsletterPlaceholder: "Enter your email",
  socialLinks: [
    { id: 1, name: "Facebook", icon: "FaFacebookF", href: "#" },
    { id: 2, name: "YouTube", icon: "FaYoutube", href: "#" },
    { id: 3, name: "Twitter", icon: "FaTwitter", href: "#" },
    { id: 4, name: "LinkedIn", icon: "FaLinkedinIn", href: "#" },
    { id: 5, name: "Instagram", icon: "FaInstagram", href: "#" },
  ],
  quickLinks: [
    { id: 1, name: "Home", href: "/" },
    { id: 2, name: "About", href: "/about" },
    { id: 3, name: "Services", href: "/services" },
    { id: 4, name: "Contact", href: "/contact" },
  ],
  footerBottomLinks: [
    { id: 1, name: "Privacy Policy", href: "#" },
    { id: 2, name: "Terms", href: "#" },
  ],
  contactInfo: [
    { id: 1, type: "address", value: "Default Address", icon: "FaMapMarkerAlt" },
    { id: 2, type: "phone", value: "+123456789", icon: "FaPhone" },
    { id: 3, type: "E-mail", value: "contact@example.com", icon: "FaEnvelope" },
  ],
};






 const staticTranslations = {
  en: {
    quickLinks: "Quick Links",
    contact: "Contact",
  },
  fr: {
    quickLinks: "Liens Rapides",
    contact: "Contact",
  },
  ar: {
    quickLinks: "روابط سريعة",
    contact: "اتصل بنا",
  }
};



// ---------------- Icon Map ----------------
/*
const iconMap: Record<string, React.ReactElement> = {
  FaFacebookF: <FaFacebookF className="w-4 h-4" />,
  FaYoutube: <FaYoutube className="w-4 h-4" />,
  FaTwitter: <FaTwitter className="w-4 h-4" />,
  FaLinkedinIn: <FaLinkedinIn className="w-4 h-4" />,
  FaInstagram: <FaInstagram className="w-4 h-4" />,
  FaMapMarkerAlt: <FaMapMarkerAlt className="w-4 h-4" />,
  FaPhone: <FaPhone className="w-4 h-4" />,
  FaEnvelope: <FaEnvelope className="w-4 h-4" />,
};*/const iconMap: Record<string, React.ReactElement> = {
  FaFacebookF: <FaFacebookF className="w-4 h-4" />,
  FaYoutube: <FaYoutube className="w-4 h-4" />,
  FaTwitter: <FaTwitter className="w-4 h-4" />,
  FaLinkedinIn: <FaLinkedinIn className="w-4 h-4" />,
  FaInstagram: <FaInstagram className="w-4 h-4" />,

  // Contact icons — same size
  FaMapMarkerAlt: <FaMapMarkerAlt className="w-4 h-4" />,
  FaPhone: <FaPhone className="w-4 h-4" />,
  FaEnvelope: <FaEnvelope className="w-4 h-4" />,
};


// ---------------- Helper Components ----------------
const SocialLinks: React.FC<{ links: SocialLink[] }> = ({ links }) => (
  <div className="flex space-x-3">
    {links.map((s) => (
      <a
        key={s.id}
        href={s.href}
        className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 ${s.bg || "bg-white/10"}`}
        aria-label={s.name}
      >
        {iconMap[s.icon] || <span>•</span>}
      </a>
    ))}
  </div>
);

const QuickLinks: React.FC<{ links: QuickLink[] }> = ({ links }) => (
  <ul className="space-y-2">
    {links.map((link) => (
      <li key={link.id}>
        <a href={link.href} className="text-gray-300 hover:text-white transition-all duration-300">
          {link.name}
        </a>
      </li>
    ))}
  </ul>
);
/*
const ContactInfoBlock: React.FC<{ info: ContactItem[] }> = ({ info }) => (
  <ul className="space-y-4">
    {info.map((item) => (
      <li key={item.id} className="flex items-start space-x-3">
        <div className="w-10 h-10 flex items-center justify-center bg-indigo-500/20 rounded-lg">
          {iconMap[item.icon] || <span>•</span>}
        </div>
        <div className="text-gray-300 text-sm">{item.value}</div>
      </li>
    ))}
  </ul>
);*/
const ContactInfoBlock: React.FC<{ info: ContactItem[] }> = ({ info }) => (
  <ul className="space-y-3">
    {info.map((item) => (
      <li
        key={item.id}
        className="flex items-start gap-3"
      >
        <div
          className="
            w-9 h-9
            min-w-9
            flex items-center justify-center
            bg-indigo-500/20
            rounded-lg
          "
        >
          {iconMap[item.icon] || (
            <span className="text-sm">•</span>
          )}
        </div>

        <div className="text-gray-300 text-sm leading-5 pt-1">
          {item.value}
        </div>
      </li>
    ))}
  </ul>
);



const NewsletterForm: React.FC<{ title: string; text: string; placeholder: string }> = ({ title, text, placeholder }) => {
  const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
        const NEXT_PUBLIC_STRAPI_URL1 = process.env.NEXT_PUBLIC_STRAPI_URL1;

/*
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    setMessage("");
         const res = await fetch(`${STRAPI_URL}/api/subscribersses`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: { email },
        }),
      });
      if (!res.ok) {
        const errorText = await res.text();
        console.error("Subscription error:", errorText);
        throw new Error("Failed to subscribe");
      }

    try {
      const res = await fetch("/api/subscribersses", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.message || "Failed to send email");
      } else {
        setMessage("Email sent successfully!");
        setEmail(""); // Clear input
      }
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
 */
 
 const handleSubmit = async (e: React.FormEvent) => {
 e.preventDefault();
 if (!email) return;

 setIsLoading(true);
 setMessage("");
 // const res = await fetch(`${NEXT_PUBLIC_STRAPI_URL1}/api/subscribersses`, {

 const res = await fetch(`${STRAPI_URL}/api/subscribersses`, {
 method: "POST",
 headers: {
 "Content-Type": "application/json",
 },
 body: JSON.stringify({
 data: { email },
 }),
 });
 if (!res.ok) {
 const errorText = await res.text();
 console.error("Subscription error:", errorText);
 throw new Error("Failed to subscribe");
 }

 try {
 const res = await fetch("/api/subscribersses", {
 method: "POST",
 headers: { "Content-Type": "application/json" },
 body: JSON.stringify({ email }),
 });

 const data = await res.json();

 if (!res.ok) {
 setMessage(data.message || "Failed to send email");
 } else {
 setMessage("Email sent successfully!");
 setEmail(""); // Clear input
 }
 } catch (err) {
 console.error(err);
 setMessage("Something went wrong");
 } finally {
 setIsLoading(false);
 }
 };



  return (
    <div>
      <h3 className="font-bold text-lg mb-3">{title}</h3>
      <p className="text-gray-300 mb-3">{text}</p>
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholder}
          className="w-full px-4 py-2 rounded-lg bg-white/10 text-white placeholder-gray-400 focus:outline-none"
          required
        />
        <button type="submit" className="px-4 py-2 bg-indigo-600 rounded-lg text-white">
          <FaPaperPlane />
        </button>
      </form>
    </div>
  );
};

// ---------------- Footer Bottom Component ----------------
const FooterBottom: React.FC<FooterBottomProps> = ({ logoUrl, logoName, links }) => (
  <div className="w-full bg-white text-gray-700 border-t border-gray-300 mt-4">
    <div className="max-w-7xl mx-auto py-2 px-4 flex flex-col items-center space-y-2">
      {logoUrl && (
        <img
          src={logoUrl}
          alt={logoName}
          className="w-8 h-8 object-contain rounded-xl bg-white/5 p-1 border border-white/10"
        />
      )}
      <div className="flex flex-wrap justify-center gap-2 text-sm">
        {links.map((link, i) => (
          <span key={link.id} className="flex items-center">
            <a href={link.href} className="hover:text-black">{link.name}</a>
            {i < links.length - 1 && <span className="mx-1">|</span>}
          </span>
        ))}
      </div>
      <p className="text-xs text-gray-600">
        Copyright © {new Date().getFullYear()} {logoName} — All rights reserved.
      </p>
    </div>
  </div>
);


// ---------------- Footer Component ----------------
const Footer: React.FC = () => {
  const { language } = useLanguage();
  const [footer, setFooter] = useState<FooterData>(defaultFooterData);
  const [loading, setLoading] = useState(true);
  const [logo, setLogo] = useState<LogoData | null>(null);
 /*
  useEffect(() => {
    const fetchFooter = async () => {
      setLoading(true);
      try {
        const logoRes = await fetch(`${process.env.NEXT_PUBLIC_STRAPI_URL}/api/logos?populate=*&locale=${language}`);
        const logoJson = await logoRes.json();
        if (logoJson.data?.length > 0) {
          const item = logoJson.data[0];
          const imageUrl = item.logo?.[0]?.url ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${item.logo[0].url}` : null;
          setLogo({ namelogo: item.namelogo || "ENAP", Reference: item.Reference, url: imageUrl });
        }

        const res = await fetch(`${process.env.NEXT_PUBLIC_STRAPI_URL}/api/footers?populate=*&locale=${language}`, { cache: "no-store" });
        const json = await res.json();
        if (json.data?.length > 0) {
          const item = json.data[0];
          setFooter({
            logoName: item.logoName,
            logoUrl: item.LogoImage?.formats?.large?.url ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${item.LogoImage.formats.large.url}` : null,
            description: item.description,
            newsletterTitle: item.newsletterTitle,
            newsletterText: item.newsletterText,
            newsletterPlaceholder: item.newsletterPlaceholder,
            socialLinks: item.Socialmedia || [],
            quickLinks: item.quickLinks || [],
            footerBottomLinks: item.footerBottomLinks || [],
            contactInfo: item.contactInfo || [],
          });
        } else setFooter(defaultFooterData);
      } catch (err) {
        console.error(err);
        setFooter(defaultFooterData);
      } finally {
        setLoading(false);
      }
    };

    fetchFooter();
  }, [language]);
 */
useEffect(() => {
  const fetchFooter = async () => {
    setLoading(true);
    try {
      // LOGO
      const logoRes = await fetch(`/api/logo?locale=${language}`);
      const logoJson = await logoRes.json();

      if (logoJson.data?.length > 0) {
        const item = logoJson.data[0];
        const imageUrl = item.logo?.[0]?.url
          ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${item.logo[0].url}`
          : null;

        setLogo({
          namelogo: item.namelogo || "ENAP",
          Reference: item.Reference,
          url: imageUrl,
        });
      }

      // FOOTER
      const res = await fetch(`/api/footer?locale=${language}`);
      const json = await res.json();

      if (json.data?.length > 0) {
        const item = json.data[0];
        setFooter({
          logoName: item.logoName,
          logoUrl: item.LogoImage?.formats?.large?.url
            ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${item.LogoImage.formats.large.url}`
            : null,
          description: item.description,
          newsletterTitle: item.newsletterTitle,
          newsletterText: item.newsletterText,
          newsletterPlaceholder: item.newsletterPlaceholder,
          socialLinks: item.Socialmedia || [],
          quickLinks: item.quickLinks || [],
          footerBottomLinks: item.footerBottomLinks || [],
          contactInfo: item.contactInfo || [],
        });
      }
    } catch (err) {
      console.error(err);
      setFooter(defaultFooterData);
    } finally {
      setLoading(false);
    }
  };

  fetchFooter();
}, [language]);


const staticTranslations: Record<string, { quickLinks: string; contact: string }> = {
  en: {
    quickLinks: "Quick Links",
    contact: "Contact",
  },
  fr: {
    quickLinks: "Liens Rapides",
    contact: "Contact",
  },
  ar: {
    quickLinks: "روابط سريعة",
    contact: "اتصل بنا",
  },
};

  const t = staticTranslations[language as string] || staticTranslations.en;



  if (loading) return <div className="text-center py-10 text-white">Loading footer...</div>;

  return (
<footer className="bg-gray-900 text-white">
  {/* Main Footer */}
  <div className="px-6 py-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6">
    {/* Company Info */}
    <div>
      {logo?.url ? (
        <img
          src={logo.url}
          alt={logo.namelogo}
          className="w-8 h-8 object-contain transition-transform duration-300"
        />
      ) : (
        <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-white bg-gradient-to-r from-blue-600 to-purple-700">
          E
        </div>
      )}
      {/*<h2 className="font-bold text-xl mb-3">{footer.logoName}</h2>*/}
      <p className="text-gray-300 mb-3">{footer.description}</p>
      <SocialLinks links={footer.socialLinks} />
    </div>

    {/* Quick Links */}
    <div>
      <h3 className="font-bold mb-3">{t.quickLinks}</h3>
      <QuickLinks links={footer.quickLinks} />
    </div>

    {/* Contact Info */}
    <div>
      <h3 className="font-bold mb-3">{t.contact}</h3>
      <ContactInfoBlock info={footer.contactInfo} />
    </div>

    {/* Newsletter */}
    <div>
      <NewsletterForm
        title={footer.newsletterTitle}
        text={footer.newsletterText}
        placeholder={footer.newsletterPlaceholder}
      />
    </div>
  </div>

  {/* Footer Bottom */}
  <FooterBottom
    logoUrl={footer.logoUrl}
    logoName={footer.logoName}
    links={footer.footerBottomLinks}
  />
</footer>

  );
};

export default Footer;




 